/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = require('../../utils/logger')('splitio-producer:offline');

function FromObjectUpdaterFactory(Fetcher, context) {
  var _context$getAll = context.getAll(),
      settings = _context$getAll[context.constants.SETTINGS],
      readiness = _context$getAll[context.constants.READINESS],
      storage = _context$getAll[context.constants.STORAGE];

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var splits, configs, name;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              splits = [];
              configs = Fetcher(settings);


              log.debug('Splits data:');
              log.debug((0, _stringify2.default)(configs));

              // Make use of the killed behavior to prevent loading all the information
              // for a given Split.
              for (name in configs) {
                splits.push([name, (0, _stringify2.default)({
                  name: name,
                  status: 'ACTIVE',
                  killed: true,
                  defaultTreatment: configs[name],
                  conditions: []
                })]);
              }_context.next = 7;
              return storage.splits.flush();

            case 7:
              _context.next = 9;
              return storage.splits.addSplits(splits);

            case 9:

              readiness.splits.emit(readiness.splits.SDK_SPLITS_ARRIVED);
              readiness.segments.emit(readiness.segments.SDK_SEGMENTS_ARRIVED);

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function ObjectUpdater() {
      return _ref.apply(this, arguments);
    }

    return ObjectUpdater;
  }();
}

module.exports = FromObjectUpdaterFactory;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/producer/updater/SplitChangesFromObject.js
// module id = 702
// module chunks = 10